<div>
  <div class="breadcrumb-block">
      <FlashMessage></FlashMessage>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link :to="{ name:'business-dashboard'}">Home</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Change Password
        </li>
      </ol>
    </nav>
  </div>
  <div class="manage-package-block">
    <div class="white-box">
      <div class="table-title pb-0">
        <h5><i class="fas fa-key"></i> Change Password</h5>
      </div>
      <hr />
      <div class="manage-user-block">
        <div class="form-modified">
          <p>Please fill up the fields below to change the password.</p>
          <div class="error-list" v-if="errorsMessage">
              <ul class="error-msg" >
                  <li v-for="(error,x) in errorsMessage" :key="x">
                      <div v-for="(err,i) in error" :key="i">
                          <p> {{err}}</p>
                        </div>
                  </li>
                </ul>
          </div>
          <form action="#">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <input
                    type="password"
                    class="form-control"
                    id="inputPassword"
                    placeholder="Old Password"
                    v-model="Password.Old"
                    :class="{ 'error-input' : errors['old_password'] }"
                  />
                  <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'old_password'" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <div class="password-input">
                      <input
                      :type="passwordFieldType"
                        class="form-control"
                        id="inputPassword"
                        placeholder="New Password"
                        v-model="Password.New"
                        :class="{ 'error-input' : errors['new_password'] }"
                      />
                      <span v-if="Password.New" toggle="#password-field" id="passwordNew" class="fa fa-fw fa-eye field-icon toggle-password" @click.prevent="switchVisibilityNew"></span>
                      <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'new_password'" />
                  </div>
                 
                </div>
              </div>
              <div class="col-md-4">
                  <div class="form-group">
                   <div class="password-input">
                      <input
                        :type="passwordFieldTypeConform"
                        class="form-control"
                        id="inputPasswordConform"
                        placeholder="Confirm Password"
                        v-model="Password.NewConfirm"
                        :class="{ 'error-input' : errors['new_confirm_password'] }"
                      />
                      <span v-if="Password.NewConfirm" toggle="#password-field" id="passwordConform" class="fa fa-fw fa-eye field-icon toggle-password" @click.prevent="switchVisibilityConform"></span>
                      <validation-error v-if="isError" :isError="isError" :errors="errors" :field="'new_confirm_password'" />
                   </div>
                  </div>
                </div>
            </div>
            <div class="form-group">
              <button type="submit" class="deault-btn" @click.prevent="changePassword">
                Change password
                <spinner v-if="ui.PostLoading" :loading="ui.PostLoading"></spinner>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
